module.exports = __webpack_public_path__ + "img/after-respond-without-resume.c88a6ce0.svg";